import { render, staticRenderFns } from "./collect-customer.vue?vue&type=template&id=2b9d020a&scoped=true"
import script from "./collect-customer.vue?vue&type=script&lang=ts"
export * from "./collect-customer.vue?vue&type=script&lang=ts"
import style0 from "./collect-customer.vue?vue&type=style&index=0&id=2b9d020a&prod&lang=scss&scoped=true"
import style1 from "./collect-customer.vue?vue&type=style&index=1&id=2b9d020a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9d020a",
  null
  
)

export default component.exports